
import { Mic, CheckCircle, AlertCircle } from 'lucide-react';
import Select from '../../../components/ui/Select';

const BrandVoiceSelector = ({ currentVoice, onVoiceChange }) => {
  const brandVoices = [
    { 
      value: 'default', 
      label: 'Default Voice',
      description: 'Standard brand communication style',
      compliance: 100
    },
    { 
      value: 'corporate', 
      label: 'Corporate',
      description: 'Formal and authoritative',
      compliance: 95
    },
    { 
      value: 'friendly', 
      label: 'Friendly',
      description: 'Warm and personable',
      compliance: 90
    },
    { 
      value: 'innovative', 
      label: 'Innovative',
      description: 'Forward-thinking and creative',
      compliance: 85
    },
    { 
      value: 'supportive', 
      label: 'Supportive',
      description: 'Helpful and encouraging',
      compliance: 92
    }
  ];

  const currentVoiceData = brandVoices?.find(v => v?.value === currentVoice) || brandVoices?.[0];

  const getComplianceColor = (score) => {
    if (score >= 90) return 'text-green-600';
    if (score >= 75) return 'text-yellow-600';
    return 'text-red-600';
  };

  const getComplianceIcon = (score) => {
    if (score >= 90) return <CheckCircle className="w-4 h-4 text-green-600" />;
    return <AlertCircle className="w-4 h-4 text-yellow-600" />;
  };

  return (
    <div>
      <div className="flex items-center gap-2 mb-2">
        <Mic className="w-4 h-4 text-gray-600" />
        <label className="text-xs font-medium text-gray-700">Brand Voice</label>
      </div>
      
      <div className="space-y-2">
        <Select
          options={brandVoices?.map(v => ({ value: v?.value, label: v?.label }))}
          value={currentVoice}
          onChange={(e) => onVoiceChange(e?.target?.value)}
        />
        
        <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
          <div className="flex-1">
            <p className="text-xs text-gray-600">{currentVoiceData?.description}</p>
          </div>
          <div className="flex items-center gap-2">
            {getComplianceIcon(currentVoiceData?.compliance)}
            <span className={`text-xs font-medium ${getComplianceColor(currentVoiceData?.compliance)}`}>
              {currentVoiceData?.compliance}% Compliant
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandVoiceSelector;